import { IBillableServiceModel } from "@/Administration/Models/UI/BillableService/IBillableServiceModel";
import { BillableServiceItem } from "@/Common/Models/BillableServiceItem";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class AdministrationBillableServiceAction extends BaseAction {
    public refreshBillableServices(model: IBillableServiceModel): void {
        var requestData = this.setRequestDataForGetBillableServices(model);
        this.Execute(ServerOperations.Server.Myle_Admin_GetAllBillableService, requestData);
    }

    public LoadFilteredBillableService(model: IBillableServiceModel): void {
        let requestData = this.setRequestDataForGetBillableServices(model);
        let sites = model.get("Sites");

        // requestData.SiteIds = sites == null ? null : sites.toArray().filter(x => x.Checked).map(x => x.Id);
        requestData.SiteIds = sites.toArray().filter(x => x.Checked).map(x => x.Id);
        if (model.get("ShowNullSites"))
            requestData.SiteIds.push(null);

        let centers = model.get("CostCenters");
        // requestData.CostCentersIds = centers == null ? null : centers.toArray().filter(x => x.Checked).map(x => x.Id);
        requestData.CostCentersIds = centers.toArray().filter(x => x.Checked).map(x => x.Id);
        if (model.get("ShowNullCostCenters"))
            requestData.CostCentersIds.push(null);

        this.Execute(ServerOperations.Server.Myle_Admin_GetAllBillableService, requestData);
    }

    private setRequestDataForGetBillableServices(model: IBillableServiceModel): any {
        var requestData = {
            SiteIds: [],
            CostCentersIds: [],
            PageSize: model.get("SelectedPageSizeOption"),
            PageNumber: model.get("SelectedPageNumber"),
            OrderByColumn: model.get("GridSortColumn"),
            OrderByDirection: model.get("GridSortDirection"),
            SearchText: model.get("BillableServiceSearchText"),
            CheckAllCostCenters: model.get("CostCenters_AllSelected"),
            CheckAllSites: model.get("Sites_AllSelected"),
            LanguageCode: sessionStore.userLanguageCode
        };

        return requestData;
    }

    public upsertBillableSErvice(service: BillableServiceItem): void {
        var requestData = {
            BillableService: service
        };
        this.Execute(ServerOperations.Server.Myle_Admin_UpsertBillableService, requestData);
    }
}

export { AdministrationBillableServiceAction };
